import { Link, NavLink } from "react-router-dom";
import React from "react";
import { useState, useEffect , useRef } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import Notification from "./Notification";
export default function Header() {
  const globalState = useGlobalState();

  function NotificationCallBack() {
    globalState.setNotificationObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
    });
  }

  return (
    <>
      <Notification
        NotificationObject={globalState.NotificationObject}
        NotificationCallBack={NotificationCallBack}
      />
    </>
  );
}
